/**
 * Android ли это и стоит ли звать человека в Play.
 *
 * **Метка `referrer` в ссылке — не украшение.** По ней Play показывает в
 * отчётах, сколько установок пришло с сайта; без неё они смешаются с
 * органическими и с рекламными, и ответить «а сработала ли полоса» будет
 * нечем. Метка должна быть закодирована целиком — Play разбирает её как один
 * параметр.
 */
import { authMode } from './auth'
import { isStandalone } from './install'

const PACKAGE = 'app.sirr'

export const PLAY_URL =
  `https://play.google.com/store/apps/details?id=${PACKAGE}` +
  `&referrer=${encodeURIComponent('utm_source=sirr.app&utm_medium=web&utm_campaign=get_app')}`

/**
 * Android в обычном браузере — и только он.
 *
 * Отсекаем по очереди:
 * - **Telegram** (`authMode`): человек уже внутри мини-приложения, у него там
 *   свои звёзды и своя реклама, и выгонять его в Play незачем;
 * - **установленная PWA** (`standalone`): он уже поставил нашу версию на
 *   экран, предлагать вторую — значит обесценить его выбор;
 * - **не Android**: на iOS приложения нет вовсе, и кнопка вела бы в пустоту.
 *
 * Смотрим на `userAgent`, потому что ничего лучше для «это Android» в браузере
 * нет: `navigator.platform` устарел, а `userAgentData` есть не везде.
 */
export function isAndroidBrowser(): boolean {
  if (authMode !== 'pwa') return false
  if (isStandalone()) return false
  try {
    return /android/i.test(navigator.userAgent)
  } catch {
    return false
  }
}
